import { menuModifierItemCardFactory } from './chunk-S57ZADSR.mjs';
import { calculatePriceText } from './chunk-G3WCWBRF.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';
import isEqual from 'lodash/isEqual';

var MODIFIER_ITEM_PRICES = [
  "includedMasterPrice",
  "additionalMasterPrice",
  "includedLightPrice",
  "includedRegularPrice",
  "includedExtraPrice",
  "additionalLightPrice",
  "additionalRegularPrice",
  "additionalExtraPrice"
];
var menuModifierItemsTableFactoryCore = (modifierItems, modifierGroups) => menuModifierItemCardFactory(modifierItems).map((modifierItem) => {
  const menuModifierItem = modifierItems[modifierItem.id];
  const prices = [];
  let arePricingVersionsDifferent = false;
  const pricingPair = Object.values(
    menuModifierItem.modifierItemPricingVersions
  ).map((pricingVersion) => {
    const pricingVersionPrices = [];
    MODIFIER_ITEM_PRICES.forEach((price) => {
      if (!pricingVersionPrices.includes(pricingVersion[price])) {
        pricingVersionPrices.push(pricingVersion[price]);
      }
      if (!prices.includes(pricingVersion[price])) {
        prices.push(pricingVersion[price]);
      }
    });
    if (!arePricingVersionsDifferent && !isEqual(prices, pricingVersionPrices)) {
      arePricingVersionsDifferent = true;
    }
    return {
      text: pricingVersion.name,
      description: calculatePriceText(pricingVersionPrices)
    };
  });
  return __spreadProps(__spreadValues({}, modifierItem), {
    pricing: pricingPair.length === 1 || !arePricingVersionsDifferent ? [__spreadProps(__spreadValues({}, pricingPair[0]), { text: "" })] : pricingPair,
    is86ed: menuModifierItem.is86ed,
    nestedModifiers: Object.values(menuModifierItem.modifierGroups).map(
      (nestedModifierGroup) => modifierGroups[nestedModifierGroup.modifierGroupId].name
    ).join(", ") || void 0,
    modifierGroups: menuModifierItem.parentModifierGroupIds.map(
      (parentModifierGroupId) => modifierGroups[parentModifierGroupId].name
    ).join(", ") || void 0
  });
});

export { menuModifierItemsTableFactoryCore };
